import Navbar from "@/components/Navbar";
import PromoBanner from "@/components/PromoBanner";
import Hero from "@/components/Hero";
import UploadSection from "@/components/UploadSection";
import Features from "@/components/Features";
import Testimonials from "@/components/Testimonials";
import HowItWorks from "@/components/HowItWorks";
import Pricing from "@/components/Pricing";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="NoteGenius — AI Notes to Flashcards, Quizzes & Summaries"
        description="Turn handwritten notes, PDFs, and images into digital text, flashcards, quizzes, and presentations with AI. Built for students."
        path="/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Product",
            name: "NoteGenius Pro",
            description: "Pro plan with expanded AI credits for students.",
            offers: {
              "@type": "Offer",
              price: "29",
              priceCurrency: "INR",
              availability: "https://schema.org/InStock",
              url: "https://notesgenius.lovable.app/#pricing",
            },
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "4.9",
              reviewCount: "1280",
              bestRating: "5",
              worstRating: "1",
            },
            review: [
              {
                "@type": "Review",
                reviewRating: {
                  "@type": "Rating",
                  ratingValue: "5",
                  bestRating: "5",
                },
                author: { "@type": "Person", name: "Ananya S." },
                reviewBody:
                  "NoteGenius Pro turned my messy handwritten notes into clean flashcards in seconds. Total game changer before exams.",
              },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "Product",
            name: "NoteGenius Premium",
            description: "Premium plan with the highest AI credit allowance.",
            offers: {
              "@type": "Offer",
              price: "49",
              priceCurrency: "INR",
              availability: "https://schema.org/InStock",
              url: "https://notesgenius.lovable.app/#pricing",
            },
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "4.9",
              reviewCount: "742",
              bestRating: "5",
              worstRating: "1",
            },
            review: [
              {
                "@type": "Review",
                reviewRating: {
                  "@type": "Rating",
                  ratingValue: "5",
                  bestRating: "5",
                },
                author: { "@type": "Person", name: "Rohit M." },
                reviewBody:
                  "Premium credits last me an entire semester. The quizzes it generates are genuinely close to what professors ask.",
              },
            ],
          },
        ]}
      />
      <PromoBanner />
      <Navbar />
      <main>
        <Hero />
        <UploadSection />
        <Features />
        <Testimonials />
        <HowItWorks />
        <Pricing />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
